import { ReactNode } from 'react';

import CloseIcon from 'assets/icons/close-small.svg';

import * as S from './Notifications.styles';

const CloseButton = ({ closeToast }: { closeToast?: () => void }) => (
  <button className="Toastify__close-button" onClick={closeToast}>
    <CloseIcon />
  </button>
);

export const Notifications = ({ hidden = false }: { hidden?: boolean }) => {
  return <S.Root closeButton={CloseButton} $hidden={hidden} />;
};

type Props = {
  isError?: boolean;
  title: string;
  text?: ReactNode;
  href: string;
  scanName?: string;
  footerContent?: () => ReactNode;
};

export const getNotificationContent = (props: Props) => {
  const { title, isError, text, href, footerContent } = props;
  const scanName = props.scanName || 'block explorer';

  return (
    <>
      <div>
        {isError && 'An error has occurred. '} {title}
      </div>
      {text && <div style={{ marginTop: 15, marginBottom: 10 }}>{text}</div>}
      <a href={href} target="_blank" rel="noopener noreferrer">
        View on {scanName}
      </a>
      {footerContent && footerContent()}
    </>
  );
};
